import agreement1 from '@/locales/Terms/FranchiseAgreement/KR/agreement1.html';
import agreement2 from '@/locales/Terms/FranchiseAgreement/KR/agreement2.html';
import agreement3 from '@/locales/Terms/FranchiseAgreement/KR/agreement3.html';
import agreement4 from '@/locales/Terms/FranchiseAgreement/KR/agreement4.html';
import agreement5 from '@/locales/Terms/FranchiseAgreement/KR/agreement5.html';
import agreement6 from '@/locales/Terms/FranchiseAgreement/KR/agreement6.html';
import agreement7 from '@/locales/Terms/FranchiseAgreement/KR/agreement7.html';
import agreement8 from '@/locales/Terms/FranchiseAgreement/KR/agreement8.html';
import agreement9 from '@/locales/Terms/FranchiseAgreement/KR/agreement9.html';
import agreement10 from '@/locales/Terms/FranchiseAgreement/KR/agreement10.html';
import agreement11 from '@/locales/Terms/FranchiseAgreement/KR/agreement11.html';
import agreement12 from '@/locales/Terms/FranchiseAgreement/KR/agreement12.html';
import agreement13 from '@/locales/Terms/FranchiseAgreement/KR/agreement13.html';
import guideline1 from '@/locales/Terms/Guideline/KR/guideline1.html';
import guideline2 from '@/locales/Terms/Guideline/KR/guideline2.html';
import legal_indication1 from '@/locales/Terms/LegalIndication/KR/legal_indication1.html';
import legal_indication2 from '@/locales/Terms/LegalIndication/KR/legal_indication2.html';
import legal_indication3 from '@/locales/Terms/LegalIndication/KR/legal_indication3.html';
import legal_indication4 from '@/locales/Terms/LegalIndication/KR/legal_indication4.html';
import legal_indication5 from '@/locales/Terms/LegalIndication/KR/legal_indication5.html';
import legal_indication6 from '@/locales/Terms/LegalIndication/KR/legal_indication6.html';
import legal_indication7 from '@/locales/Terms/LegalIndication/KR/legal_indication7.html';
import legal_indication8 from '@/locales/Terms/LegalIndication/KR/legal_indication8.html';
import privacy_policy1 from '@/locales/Terms/PrivacyPolicy/KR/privacy_policy1.html';
import privacy_policy2 from '@/locales/Terms/PrivacyPolicy/KR/privacy_policy2.html';
import privacy_policy3 from '@/locales/Terms/PrivacyPolicy/KR/privacy_policy3.html';
// New UI translation
import new_ui from '@/locales/NewUI';
export default {
	locale_order: 3,
	locale_name: '한국어',
	terms: {
		title: '원더 서비스 이용약관',
		agreement1,
		agreement2,
		agreement3,
		agreement4,
		agreement5,
		agreement6,
		agreement7,
		agreement8,
		agreement9,
		agreement10,
		agreement11,
		agreement12,
		agreement13,
		guideline1,
		guideline2,
		legal_indication1,
		legal_indication2,
		legal_indication3,
		legal_indication4,
		legal_indication5,
		legal_indication6,
		legal_indication7,
		legal_indication8,
		privacy_policy1,
		privacy_policy2,
		privacy_policy3,
		menu: {
			category1: '가맹점 규약',
			title1: '가맹점 약관(온라인 결제용)',
			title2: '온라인 결제 관련 API 이용 특약',
			title3: '잔액가맹점약관(온라인결제용)',
			title4:
				'신용카드가맹점약관(통신판매가맹점용)',
			title5: '원더 비즈니스용 이용약관(온라인 결제용)',
			title6: '후불 가맹점 약관(온라인 결제용)',
			title7: '데이터 이용 특약',
			title8: '상품 등 대금 지불에 관한 특약',
			title9: '선불 서비스 취급에 관한 특약',
			title10: '가맹점 약관 (미니 앱용)',
			title11: '데이터 이용 특약(미니 앱용)',
			title12: '제3조 계약의 성립_프라이버시정책',
			title13: '가맹점정보의 공동이용에 대하여',
			category2: '가이드라인',
			title14: '가맹점 가이드라인(미니앱용)',
			title15: '가맹점 가이드라인(온라인)',
			category3: '법령상의 표시',
			title16: '은행대리업 개요',
			title17: '취급상품 카드론 개인 금리 등',
			title18: '취급상품 카드론 개인 상품개요',
			title19: '엔보통예금계좌 금리 등',
			title20: '엔보통예금계좌 상품개요',
			title21: '취급상품 비지니스론 금리 등',
			title22: '취급상품 비지니스론 상품개요',
			title23:
				'당사 대출을 여러 개 계약했을 경우의 적용 금리에 대해',
			category4: '프라이버시정책',
			title24: '개인정보공개청구',
			title25: '사용자 보안에 대하여',
			title26: '관계회사',
		},
	},
	cookies: {
		title: '쿠키(Cookies) 이용방침',
		text1:
			'JPWORLDPAY는 출처 및 기타 통계 자료를 얻기 위하여 웹사이트 이용자의 검색정보를 익명으로 수집함에 있어 쿠키(Cookie)를 사용합니다.',
		text2:
			'쿠키(Cookie)란 예를들어 상품 구매 과정, 검색 성향 및 활동 등을 기록하기 위한 웹사이트의 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다.',
		text3: '특히 다음과 같이 사용됩니다:',
		text4:
			'Google Analytics. 구글은 자사의 서비스 개선과 타사에 서비스를 제공하기 위하여 이 정보를 이용할 수 있습니다.',
		text5: '다음 링크를 통해 모든 정보에 접근할 수 있습니다.',
		text6: '데이터 보호하기',
		text7: '애널리틱스 차단 브라우저 부가 기능',
		text8:
			'위 도구는 이용자의 성명, 주소 및 접속 정보를 수집하지 않습니다. 수집되는 이용자의 정보는 예를 들어 접속 사이트 수, 사용언어, 이용자 아이피가 표시하는 도시, 방문자 수, 재방문 수, 접속시간, 사용하는 브라우저, 운영자 또는 터미널 유형 등과 관련되어 있습니다. 위 정보는 새로운 요구사항을 파악하고 개선 노력에 대한 평가를 통해 이용자들에게 보다 나은 웹사이트의 서비스를 제공하기 위하여 사용됩니다.',
		text9:
			'소셜 네트워크에서 사용하는 쿠키(Cookie). 이 웹사이트에서는 사용자의 관심 콘텐츠를 소셜 그룹과 공유할 수 있도록 소셜 네트워크 버튼이 설치되어 있습니다. 소셜 네트워크를 통해 저장된 쿠키(Cookie)는 위 콘텐츠 공유에 있어 개인정보 재입력의 불편을 방지합니다.',
		text10:
			'이용자는 컴퓨터에 설치되어 있는 웹브라우저의 도구 옵션을 통하여 모든 쿠키(Cookies)를 허용/거부 하거나 삭제 또는 쿠키가 저장될 때마다 확인을 거치도록 할 수 있습니다.',
		text11:
			'아래의 링크에서 사용하는 각 웹브라우저에 따른 기능 정보를 찾아볼 수 있습니다:',
		text12: '파이어폭스',
		text13: '크롬',
		text14: '사파리',
	},
	rtr_footer: {
		text1: '모든 권리 보유',
	},

	rtr_home: {
		text1: '아직도 암호자산으로',
		text2: '결제가 불가능 하다고',
		text3: '생각 하시나요?',
		text4: '암호자산을 환전하지 않고 바로 결제가능',
		button1: '암호자산 즉시결제',
		text5: '원더,',
		text6: '안전과 속도를 동시에',
		text7: '블록체인의 안전성과 원더만의 기술력으로',
		text8: '가장 빠른 결제 시스템을 만나보시기 바랍니다.',
		text9: '회원 가입하기',
		text10: '우리는',
		text11: '무료로 제공합니다.',
		text12: '기술은 최고, 서비스도 최고, 최고의 플랫폼',
		text13: '그래도 원더는 무료입니다.',
		text14: '무료 계정 만드는 방법',
		text15: '원더는,',
		text16: '장점이 너무 많습니다.',
		text17: '원더는 카드가 필요 없습니다.',
		text18: '네트워크만 연결되어 있으면 어디에서든',
		text19: '원더에 접속해서 결제가 가능합니다.',
		text20: 'QR코드를 통해 즉시 결제도 가능합니다.',
		text21: '오프라인에서는 키오스크와 포스기를 통해',
		text21_1: '결제도 가능합니다.',
		text22: '쇼핑 및 구매방법',
		text23: '원더 결제',
		text24: '어디에서든 결제 가능',
		text25: 'QR코드 결제',
		text26: '결제 QR코드로 간편하게 결제',
		text27: '키오스크와 포스',
		text28: '오프라인에서 편리하게 결제',
		text29: '전 세계 어디에서나 사용이 가능합니다.',
		text30: '누구나 사용이 가능하고 어디에서나 사용이 가능합니다.',
		text31: '암호자산의 가장 큰 매력을 원더는 알고 있습니다.',
		text32:
			'우리는 전세계에 암호자산의 사용 방법에 대해 알려주는 길잡이가 되려 합니다.',
		button2: '무료로 시작하기',
		text33: '비즈니스 회원 마저도',
		text34: '무료로 사용하세요.',
		text35: '비즈니스를 폭 넓게 하는 방법을 찾고 있으신가요?',
		text36: '아직도 통화쌍으로만 결제하시나요?',
		text37: '전세계 인구가 사용 중인 암호자산으로 결제를 받아보세요.',
		text38: '비즈니스 상점 개설',
		text39: '우리는',
		text40: '당신의 목소리를 듣습니다.',
		text41: '원더는 항상 고객분들의 말을 듣고',
		text42: '실천하고 있습니다.',
		text43: '문의하기',
	},
	'rtr_personal-how-online_shopping': {
		title1: '원더로 결제하기',
		text1: '원하는 암호화폐를 추가하고 원하는 곳에서',
		text2: '유연하게 쇼핑을 경험하시기 바랍니다.',
		text3: '전자지갑에만 있는 암호화폐를',
		text4: '원더',
		text5: '를 통해 ',
		text6: '어디서든 간편하게 쇼핑을 즐기시기 바랍니다.',
		text7: '원더에 원하는 ',
		text8: '암호화폐 지갑을 만드세요.',
		text9: '쇼핑몰 결제시',
		text10: '원더를 선택하세요.',
		text11: '원더에서 원하는',
		text12: '암호화폐로 결제하세요.',
		title2: '다시 한 번',
		title3: '즐기시기 바랍니다.',
		text13: '원더로 구입하고 포인트를 받아',
		text14: '또 한 번 구입하시기 바랍니다.',
		text15: '원더 포인트는 원더를 사용하는',
		text16: '모든 가맹점에서 사용이 가능합니다.',
		title4: '안심하고',
		title5: '결제하세요.',
		text17: '원더의 보안은 세계 최고를 자랑합니다.',
		text18: '고객님의 암호화폐와 자산을 안전하게 지켜드리고',
		text19: '안전하게 사용 할 수 있게 해드립니다.',
	},
	'rtr_personal-how-offline_kiosk': {
		title1: '오프라인 가맹점을',
		title2: '이용하는 방법',
		text1: '고객이 직접 빠른 결제가 가능합니다.',
		text2: '현금이나 카드 없이 휴대폰만 있으면 즉시 결제가 가능한',
		text3: '원더를 사용해 보시기 바랍니다.',
		text4: '원더',
		text5: '를 이용한 결제방법',
		text6: '휴대폰에서 원더를',
		text7: '선택하고 실행하세요.',
		text8: '지갑을 선택해서',
		text9: '‘오프라인 상점 결제’를 선택하세요. ',
		text10: 'QR코드를 키오스크에',
		text11: '스캔하시면 결제 끝.',
		text12: '미래화폐 시스템에 ',
		text13: '오신 것을 환영합니다.',
		text14: '안전한 결제',
		text15: '오프라인 결제 시 고객님의 정보가 남지 않습니다.',
		text16: '가까운 가맹점에서',
		text17: '언제 어디서나 원더가 가맹 된 곳을 찾아 사용하세요.',
		text18: '현금없이',
		text19: '아직도 현금을 들고 다니시나요? 휴대폰에서 원더를 바로 사용하세요.',
		title3: '판매자도',
		title4: '쉽게 접근하세요.',
		text20: '원더 키오스크에 판매 물품만 등록하면 끝.',
		text21: '결제는 원더 키오스크가 해드립니다.',
	},
	'rtr_personal-how-qr': {
		title1: 'JPWORLDPAY로 자주 가는',
		title2: '매장에서 결제하세요.',
		text1: '직접 결제하는 것은 결제시 QR코드를',
		text2: '스캔하는 것 만큼 쉽고 터치가 필요 없습니다.',
		text3: '카드나 현금을 취급 할 필요가 없으며 앱을 사용하기만 하면 됩니다.',
		text4: '미래화폐 시스템에 오신 것을 환영합니다.',
		text5: '안전한 결제',
		text6: 'JPWORLDPAY는 QR코드 거래 중에는',
		text7: '자신의 정보가 노출되지 않습니다.',
		text8: '어느 업체에서나',
		text9: '가맹점 어디서나 24시간 어디서나',
		text10: '오프라인 가맹점에서 결제를',
		text11: '하시기 바랍니다.',
		text12: '터치 프리, 현금 없음',
		text13: '현금이나 카드 걱정하지말고',
		text14: '어플을 열고 결제하시기 바랍니다.',
		text15: 'QR로 3단계 결제',
		text16: 'JPWORLDPAY',
		text17: '어플과 계정이 필요합니다.',
		text18: 'STEP 01. 스캔 또는 표시',
		text19: 'STEP 02. 지불',
		text20: 'STEP 03. 확인',
		text21: 'QR 아이콘을 탭하고 판매자가 코드를 제시하면',
		text22: '스캔을 선택하거나 QR코드를 요청하는 경우',
		text23: '지불하기 위해 표시를 탭하십시오.',
		text24: 'QR 코드가 표시되면 코드 스캔',
		text25: '결제 확인을 수신하면 모든 결제가 완료됩니다.',
		title3: 'QR 코드로',
		title4: '판매를 준비하세요.',
		text26: '사업을 시작하든 운영하든, 하드웨어, 소프트웨어',
		text27: '또는 카드 리더 없이도 터치가 필요없는 대면 결제를',
		text28: '쉽게 수락 할 수 있습니다.',
		text29: 'STEP 01.',
		text30: '스캔 또는 표시',
		text31: 'STEP 02.',
		text32: '지불',
		text33: 'STEP 03.',
		text34: '확인',
	},
	'rtr_personal-how-janopay_creditcard': {
		title1: '원더 카드',
		text1: '직불 및 선불 카드로 원더 잔액에 엑세스 하거나',
		text2: '신용 제품 중 하나로 일상적인 구매에 쉽게 자금을',
		text3: '조달할 수 있습니다.',
		title2: '원더 크레딧',
		title3: '지금 구매하고 시간이 지남에 따라 지불.',
		text4: '원더가 허용되는 모든 곳에서',
		text5: '만엔 이상 구매 시 특별 금융을 받으세요.',
		text6: '만엔을 구매 할 때 마다 6개월 이내에',
		text7: '전액을 지불하는 경우 이자가 없습니다.',
		text8: '6개월 이내에 잔액을 완납하지 않으면 구매일로부터',
		text9: '이자가 귀하의 계정으로 청구됩니다.',
		text10: '최소 월별 지불이 필요합니다. 신용 승인 대상.',
		text11: '쇼핑 및 구매방법',
		text12: '원더가 허용되는',
		text13: '모든 곳에서 사용 가능',
		text14: '연회비 없음',
		text15: '원더 계정에서',
		text16: '원더 코인 엑세스',
		title4: '새로운',
		title5: '원더 캐시백 (엔 코인)',
		text17: '원더 구매 시 무제한 3% 캐시백',
		text18: '기타 모든 구매 시 무제한 2%를 받으세요.',
		text19: '언제 사용 할 수 있는지 가장 먼저 알아보세요.',
		text20: '기존 2% 캐쉬백 소지자는 목록에 가입 할 필요가 없습니다.',
		text21: '업그레이드를 자동으로 받게 됩니다.',
		title6: '원더 현금카드',
		text22: '원더 잔액에 연결 된 직불카드로',
		text23: '자금에 액세스하여',
		text24: '자금을 쉽게 관리 할 수 있습니다.',
		text25: '원더 현금카드 정보',
		text26: '원더 크레딧에 대해 알아보기',
		text27: '약관보기',
	},
	'rtr_personal-how-trade_and_cashback': {
		title1: '원더을 사용하면',
		title2: '보상이 추가됩니다.',
		text1: '거래, 캐시백 제안 및 프로모션 코드를 쌓아',
		text2: '돈을 절약하고 최고의 매장과 좋아하는 브랜드에서',
		text3: '보상을 받으세요. ',
		title3: '나에게 맞는 암호화폐로 거래',
		text4: '우리는 당신이 쇼핑하고 구매하는 장소를 기반으로 당신이',
		text5: '좋아 할 것으로 생각되는 거래, 제품 및 상점을 선 보일 것이며',
		text6:
			'즐겨찾는 상점 또한 지속적으로 늘려나가며 업데이트 할 것을 약속합니다.',
		title4: '보상을 극대화하세요',
		title5: '보상 극대화',
		text7: '거래, 캐시백 제안 및 프로모션 코드를 결합하면',
		text8: '더 많은 비용을 절약 할 수 있습니다.',
		text9: '결제 시 프로모션 코드를 찾고 적용하는데',
		text10: '도움을 드리겠습니다.',
		text11: '원더 카드가 보상을 제공합니까?',
		text12: '구매에 대해 체크아웃하고 보상을 받을 때 사용하십시오.',
		text13: '쇼핑 시작',
		title6: '보안 체크아웃',
		text14: '원더로 안전하게 결제 할 때 수백만개의',
		text15: '글로벌 소매업체에서 거래 및 캐시백 제안을 활용하세요.',
		text16: '귀하의 정보는 암호화 되어 있으며 귀하의 허락 없이',
		text17: '판매하거나 공유하지 않습니다.',
		text18: '귀하를 보호 할 수 있는 방법 알아보기',
	},
	'rtr_personal-request-send': {
		title1: '온라인으로 송금하는',
		title2: '안전하고 재미있는 방법',
		text1: '전 세계 거의 모든 곳에서 가족과 친구에게 ',
		text2: '빠르게 송금 할 수 있는 간단한 방법입니다.',
		text3: '모든 전송을 최대한 활용 ',
		text4: '양방향 메시지',
		text5: '친구 간의 결제가 맞는지',
		text6: '한번 더 확인을 위해',
		text7: '메시지를 교환하세요.',
		text8: '무료 옵션',
		text9: '원더 포인트 카드 사용,',
		text10: '원더 잔액을 확인 후 해외에서',
		text11: '온라인으로 송금 할 수 있습니다.',
		text12: '빠른 액세스',
		text13: '암호화폐 송금시',
		text14: '받는 사람은 기다림 없이',
		text15: '바로 받을 수 있습니다.',
		title4: '연중무휴 모니터링',
		text16: '암호화 기술을 통해 우리는 귀하의 송금이 안전한지',
		text17: '확인하기 위해 최선을 다합니다.',
		title5: '전 세계로 송금',
		text18: '수취인에게 원더 서비스를 사용하여',
		text19: '전 세계 어디든 송금하세요.',
		text20: '전 세계 어디든 친구 및 가족에게 온라인으로 송금',
		text21: '0엔 ',
		text22: '원더 내 거래 수수료',
		text23: '타행지갑  출금시',
		text24: '원더 잔액에서 돈을 보낼 때 0%',
	},
	'rtr_personal-request-receive': {
		title1: '편안하게 요청',
		text1: '친구와 가족은 알림 없이',
		text2: '암호화폐를 요청 하실 수 있습니다.',
		title2: '편안한 자산 요청 서비스',
		text3: '편안하고 사용이 쉬운 요청',
		text4: '인스턴트 양방향 메시징',
		title3: '번거로움 없이',
		title4: '무료 요청 서비스',
		text5: '친구에게 쉽게 돈을 요청하고 기다리면',
		text6: '자동으로 입금이 됩니다.',
		title5: '쉬운 설정',
		text7: '친구가 원더 계정이 없는 경우',
		text8: '몇 분 안에 회원가입만 하면 끝.',
		text9: '급여를 보내는 것은 쉽습니다.',
		text10: '앱을 열고 지불 받기를 선택하십시오.',
		title6: '원더 사용자를 선택하고',
		title7: '요청한 금액을 입력하세요.',
		title8: '보안 체크아웃',
		text11: '순식간에 원더 자산요청 링크를 만들어 매일매일',
		text12: '암호화폐를 받는 일을 간단하게 만들 수 있습니다.',
		text13: '원더 링크 만들기',
	},
	'rtr_personal-request-deposit': {
		text1: '입금 받기',
		text2: '원더에서 편리하게 입금을 받으세요.',
		text3: '가장 편리한 입금',
		text4: '상대방 이메일로 보내면 끝',
		text5: '받는 사람에게 표시되는 것',
		text6: '원더와',
		text7: '원더 간의 송금',
		text8: '원더에서 원더로 송금 시',
		text9: '사용되는 계좌번호가 노출됩니다.',
		text10: '외부에서',
		text11: '원더로 입금',
		text12: '외부에서 원더로 입금 시',
		text13: '사용되는 지갑 주소가 노출됩니다.',
	},
	'rtr_personal-request-commission': {
		text1: '송금 수수료 무료',
		text2: '원더간의 송금시 수수료 무료!',
		text3: '외부 지갑 입금시',
		text4: '네트워크비용만',
		text5: '입금시 원더에서는',
		text6: '수수료 지불요청을 하지 않습니다.',
		text7: '자사의플랫폼 내의',
		text8: '이동은 무료입니다.',
		text9: '외부 출금시에만 수수료 발생',
		text10: '원더를 이용하여 구입시 수수료 무료',
	},
	'rtr_personal-asset-wallet': {
		text1: '국제 규격 지갑 사용',
		text2: '보안에 보안을 한 자체 지갑',
		text3: '외부 지갑 업체가 아닌 자체 기술력으로 개발한 지갑을 사용합니다.',
		text4: '국제 규격에 맞춘',
		text5: '레벨 2 이상의 보안',
		text6: '한 번 더 보안을 신경써서',
		text7: '해킹을 완벽하게 차단합니다.',
		text8: '개인키가',
		text9: '발생하지 않습니다.',
		text10: '관리자 및 DB 해킹이 들어와도',
		text11: '개인키가 없어서 해킹이 어렵습니다.',
		text12: '지갑이란',
		text13: '고객님의 금고와 같습니다.',
		text14: '저희 원더는 자체 지갑을 제작 후',
		text15: '보안에 보안을 거듭한 지갑이기에 해킹 대응에',
		text16: '최적화 되어 보안에 자신감을 가지고 있습니다.',
	},
	'rtr_personal-asset-account': {
		text1: '원더 자체 계좌 시스템',
		text2: '은행에만 계좌가 있는 것이 아닙니다.',
		text3: '원더 제공 계좌로 더욱 편리하게 이용하세요.',
		text4: '자체 계좌 시스템으로',
		text5: '더욱 빠르게',
		text6: '원더에서 원더 계좌로 송금시',
		text7: '1~3초 안에 송금이 가능하게 되었습니다.',
		text8: '이제는 기다리지 마세요.',
		text9: '송금 시스템을 만들다',
		text10: '계좌를 이용한 원더에서 원더로 송금시',
		text11: '수수료 무료, 시간 절약까지',
		text12: '원더 계좌 시스템으로 빠른 송금',
		text13: '지금 사용해보세요.',
	},
	'rtr_personal-asset-jpys': {
		text1: '엔 자체 포인트 시스템',
		text2: '빠르고 안전한 자체 포인트 시스템',
		text3: '고정된 환율 제공으로 피곤함이 없다.',
		text4: '모든 시스템과 연동',
		text5: '오프라인 매장 및 온라인 스토어 모두',
		text6: '엔 하나만 있으면 다 됩니다.',
		text7: '키오스크 및 포스기',
		text8: '어디에서나 결제를 자유롭게',
		text9: '편리한 충전',
		text10: '원하는 암호자산 및 신용카드로',
		text11: '즉시 충전이 가능합니다.',
	},
	'rtr_personal-asset-sale': {
		title1: '판매하기',
		text1: '암호자산 판매가 어렵나요?',
		text2: '아직도 구매자를 기다리시나요?',
		title2: '암호자산 판매가',
		title3: '너무 쉬워졌습니다.',
		text3: '고객과 고객간의 판매,',
		text4: '고객이 직접 원더에 판매',
		text5: '선호하는 방법으로 판매하세요.',
		title4: '버튼 한 번으로',
		title5: '환율이 자동 적용',
		text6: '버튼 한 번으로 현재 시세가',
		text7: '자동으로 적용되어 바로 판매가 가능합니다.',
	},
	'rtr_personal-asset-exchange': {
		title1: '은행과 같은 환전',
		text1: '판매 하고 구매 하고',
		text2: '아직도 이쪽 저쪽 다니면서 환전 하시나요?',
		title2: '환전 하고 바로 송금',
		text3: '아직도 암호 자산 구입하고 보내기가 힘드신가요?',
		text4: '은행처럼 사용하세요. 바로 송금 및 출금이 가능합니다.',
		title3: '버튼 한 번으로',
		title4: '쉽게 환전하세요.',
		text5: '자동 환율, 자동 판매',
		text6: '너무 쉬운 인터페이스',
		title5: '원하는 자산과 언제든지',
		text7: '암호 자산과 암호 자산 간의 환전도 가능',
		text8: '암호 자산을 엔 포인트로 환전도 가능',
	},
	'rtr_business-how-start': {
		title1: '시작하기',
		text1: '모든 것은 비즈니스 계정에서 시작됩니다.',
		text2: '원더에 의존하는 3천만명 이상의 판매자와 함께 하십시오.',
		text3: '시작하려면 계정 전문가에게 문의하세요.',
		title2: '쉬운 설정',
		text4: '문의하기.',
		text5: '도와드립니다.',
		// text6: 'help@janopay.com',
		title3: '가입은 무료입니다.',
		text7: '이메일 주소와 비즈니스에 대한',
		text8: '몇 가지 기본 정보만 있으면 됩니다.',
		text9: '비즈니스 계정에 가입',
		title4: '지급 시작',
		text10: '이메일 주소와 회사 이름을 확인하고',
		text11: '원더 계좌를 연결하면 첫 번째',
		text12: '판매준비가 완료됩니다.',
	},
	'rtr_business-how-receive': {
		title1: '온라인 및',
		title2: '대면 결제 수락',
		title3: '경쟁 우위 확보',
		title4: '고객이 요구하는 유연성',
		title5: '전세계 구매자와 연결',
		title6: '온라인 결제 수락',
		title7: '온라인 체크아웃',
		title8: '송장 및 견적',
		title9: '소셜에서 판매',
		title10: '온라인 암호화폐 결제 시스템',
		title11: '직접 지불 수락',
		title12: '판매 시점',
		text1: '시작하려면 계정 전문가에게 문의하세요.',
		text2: '우리는 소기업이 거의 모든 곳에서 지불을 받을 수 있도록 돕습니다.',
		text3: '고객이 나중에 결제하거나, 구독에 등록하거나,',
		text4: '글로벌 또는 로컬 결제 옵션을 사용하도록 하세요.',
		text5: '모든 암호화폐로 온라인 또는 매장에서',
		text6: '결제를 수락합니다.',
		text7: '고객이 원하는 방식으로 결제하고 빠르게',
		text8: '결제 할 수 있도록 하세요. ',
		text9: '여기',
		text10: '에서 온라인으로',
		text11: '지불을 수락하는 방법에 대해 자세히 알아보세요.',
		text12:
			'고객은 단일 솔루션으로 사이트, 모바일 또는 앱에서 다양한 결제 수단을',
		text13: '사용 할 수 있습니다.',
		text14: '온라인 체크아웃에 대한 추가 정보',
		text15: '구독 서비스에 대한 추가 정보',
		text16:
			'고객이 쉽게 지불 할 수 있는 맞춤형 무료 인보이스를 보내어 지불을 독려',
		text17: '할 수 있습니다.',
		text18: '인보이스 발행에 대한 추가 정보',
		text19: '다양한 소셜 미디어 플랫폼에서 저희 원더 결제 시스템을 이용하여',
		text20: '결제를 받으십시오.',
		text21: '소셜에서 판매하기에 대해 자세히 알아보기',
		text22: '당사의 신용 및 온라인 결제 서비스를 통해 대부분의 주요',
		text23: '암호화폐를 통해 온라인 및 매장 내 결제를 수락 할 수 있습니다.',
		text24: '고객이 직접 쇼핑하는 동안 비용을 지불하게 하십시오.',
		text25: '여기',
		text26: '에서 작동 방식을 알아보세요.',
		text27: '모든 인기있는 결제 유형을 수락하고 판매를 추적하며 완벽한',
		text28: 'POS 솔루션인 원더 설정 비즈니스를 관리하세요.',
		text29: '원더 설정에 대해 자세히 알아보기',
	},
	'rtr_business-how-pay': {
		title1: '비즈니스 결제 및 자금 액세스',
		title2: '편리하게 구매하세요.',
		title3: '결제만 하면',
		title4: '지불금',
		title5: '오늘 시작하기',
		text1: '저희와 함께 송금, 지출 및 이동 시',
		text2: '비즈니스 거래를 간소화 하십시오.',
		text3:
			'귀하의 비즈니스에 고도로 맞춤화 가능한 상거래 솔루션이 필요하십니까?',
		text4: '기업용 원더에 대해 알아보기',
		text5: '원더 잔액을 사용하여',
		text6: '온라인 및 직접 비즈니스 비용을 지불하십시오.',
		text7: '자금을 전자적으로 보내 시간과 수고를 절약하십시오.',
		text8: '송금 방법 알아보기',
		text9: '동시에 여러 사람과 장소에 편하게 보낼 수 있습니다.',
		text10: '판매 대금에 대해 자세히 알아보기',
		text11: '원더에 의존하는 판매자와 함께 하십시오.',
		text12: '비즈니스 계정에 가입',
		text13:
			'1. 원더로 돈을 유지하고 사용하려면 원더 비즈니스 계정 또는 원더 잔액 계정이 있어야 합니다.',
		text14:
			'2. 원더 비즈니스 직불 블록체인 구입시 보너스 캐쉬백을 받을 수 있는 거래는 다음과 같습니다. 귀하가 서명하고 블록체인카드가 처리하는 신용 ​​거래. 캐쉬백 제안을 받을 수 없는 거래에는 현금 인출, 현금 서비스로 처리되는 거래 또는 핀을 사용하는 거래',
		text15:
			'원더 비즈니스 직불 블록체인는 원더에서 발급합니다. 카드는 블록체인이 원더가 허용되는 모든 곳에서 사용할 수 있습니다. 이는 카드 발급자일 뿐이며 원더의 관련 계정이나 기타 제품, 서비스 또는 제안에 대해 책임을 지지 않습니다.',
	},
	'rtr_business-how-risk': {
		title1: '고객님의 마음과',
		title2: '소비자를 위한 것',
		title3: '풍부한 경험',
		title4: '안전하게 거래',
		title5: '사기 탐지 기술',
		text1: '기계 학습을 사용하여 비즈니스를 보호하고',
		text2: '고객님의 자산과 소비자를 모두 보호 할 수 있습니다.',
		text3:
			'귀하의 비즈니스에 고도로 맞춤화 가능한 상거래 솔루션이 필요하십니까?',
		text4: '기업용 원더에 대해 알아보기',
		text5:
			'블록체인이 알려지기 시작부터 시작 된 블록체인 노하우를 바탕으로 만들어진',
		text6: '원더를 통해 거래를 안전하게 사용해보시기 바랍니다.',
		text7: '세계에서 가장 안전한 블록체인을 토대로',
		text8: '전 세계의 고객에게 다가갈 수 있습니다.',
		text9: '당사의 사기 탐지 도구는 거래가 있을 때 마다 더욱 지능화되어',
		text10: '기존 및 진화하는 위협으로부터 귀하를 보호합니다.',
	},
	'rtr_business-operation-corps': {
		title1: '기업에 관해',
		text1: '보안과 관리는 저희가 합니다.',
		text2: '운영에만 신경 쓰시면 됩니다.',
		title2: '가맹점 관리도 자동으로',
		text3: '아직도 일일이 관리를 하고 계신가요?',
		text4: '원더만 사용하면 자동으로',
		title3: '회원가입하고 가맹점 등록 끝',
		text5: '가맹점 관리 프로그램 무료.',
		text6: '사용료 없이 평생 무료 사용.',
	},
	'rtr_business-operation-platform': {
		title1: '플랫폼 및 기능',
		text1: '기업관리에 최적화.',
		text2: '오로지 기업에 맞추어져 있습니다.',
		title2: '가맹점 관리에서부터',
		title3: '정확한 정산까지',
		text3: '기업에 최적화된 플랫폼을 만나보세요.',
		title4: '직관적이고 심플합니다.',
		text4: '기업에 관해서는 최대한 심플하게',
		title5: '배우지 않아도',
		title6: '바로 사용 가능하게',
		text5: '플랫폼과 기능을 최대한 심플하게.',
		text6: '그래서 관리자가 쉽게 사용 가능합니다.',
	},
	'rtr_business-operation-pay': {
		title1: '지불 방법',
		text1: '고객은 휴대폰 하나로 가맹점에 지불 가능.',
		title2: '가맹점에 지불된',
		title3: '원더는',
		text2: '가맹점별로 정산 또는 전체 가맹점 정산',
		title4: '정산된 원더는 고정되어',
		title5: '언제든지 출금 가능합니다.',
	},
	'rtr_business-operation-global': {
		title1: '글로벌 결제 처리',
		text1: '원더를 받아서 원하는 나라에 맞게 출금 가능.',
		title2: '현재 환율에 자동 적용',
		text2: '언제든지 원하는 시간에 출금.',
		title3: '원더 고객은 나라에',
		title4: '상관없이 결제 가능합니다.',
		title5: '암호화폐를 사용하는 이유',
		text3: '가장 좋은 이유는 환율의 개수만 보면 되기 때문입니다.',
	},
	'rtr_business-asset-pay': {
		title1: '원더 가맹점 등록',
		text1: '고객이 지불한 페이는 등록된 가맹점 별로 정산',
		title2: '가맹점이 많아도',
		title3: '한번에 전체 정산',
		text2: '품목별까지 꼼꼼하게 놓치지 않고 정산됩니다.',
		title4: '언제든지',
		title5: '원하는 방식으로 지불',
		text3: '암호화폐로 지불할 수 있고',
		text4: '원하는 통화쌍으로 지불이 가능합니다.',
	},
	'rtr_development-development': {
		text1: '각종 결제',
		text2: '빠르게 연결됨',
		text3: '편리한 ',
		text4: '자세히 알아보기',
	},
	'rtr_development-developmain': {
		text1: '지불',
		text2: '이용한 결제 시스템 원더 API',
		text3: '회원가입',
		text4: '회원가입을 해주세요 원더 홈페이지.',
		text5: '로그인',
		text6: '모두 원더 로그인 후 서비스를 이용하실 수 있습니다.',
		text7: '가맹점 등록',
		text8:
			'제휴 메뉴에서 제휴 매장을 등록하실 수 있습니다. 제휴 매장 이름과 ID를 입력해 주세요..',
		text9: 'API 발급',
		text10: '간편결제',
		text11: '편리하게 사용하실 수 있습니다 원더 결제 시스템.',
		text12: '지불',
		text13: '가맹점 등록',
		text14: '간편결제',
		text15: '퀵 가이드',
		text16: '로렘 입숨 로렘 입숨 로렘 입숨',
		text17: '로렘 입숨 로렘 입숨 로렘 입숨',
		text18: '로렘 입숨 로렘 입숨 로렘 입숨',
		text19: '로렘 입숨 로렘 입숨 로렘 입숨',
		text20: '제목',
		text21: '필수 파라미터',
		text22: '꼬리표',
		text23: '꼬리표',
		text24: '꼬리표',
		text25: '판매자 이름',
		text26: '끈',
		text27: '상표',
		text28: '상표',
		text29: '상표',
		text30: '판매자_ID',
		text31: '끈',
		text32: '상표',
		text33: '상표',
		text34: '상표',
		text35: '1단계',
	},
	cs: {
		title: '고객센터',
		notice: '공지사항',
		inquiry: {
			inquiry: '1:1 문의',
			list: '문의 내역',
			type: '문의 유형',
			title: '제목',
			date: '등록일',
			status: '상태',
			pending: '대기',
			complete: '완료',
			no_content: '등록된 내용이 없습니다.',
			text1: '작성하신 문의 내용이',
			text2: '정상적으로 접수 완료',
			text3: '되었습니다.',
		},
		faq: '자주 묻는 질문',
		ticket: {
			id: 'Ticket ID',
			text1: '문의에 대한 답변 확인시 필요한 ID 입니다.',
			text2: '문의내역 확인을 위해 PIN 코드를 입력하세요.',
			text3: '문의내역 확인 ',
			text4: '문의시 발급 받은 Ticket ID와',
			text5: '비밀번호를 입력하세요. ',
			input1: 'Ticket ID를 입력하세요.',
			input2: '비밀번호를 입력하세요.',
		},
		placeholder: {
			type: '문의 유형을 선택 해 주세요.',
			title: '제목을 입력하세요.',
			content: '문의 내용을 입력하세요.',
		},
	},
	'rtr_auth-login': {
		text1: '아이디/비밀번호를 잊으셨나요?',
	},
	'rtr_auth-find-account': {
		text1: '아이디 찾기',
		text2: '비밀번호 찾기',
		text3: 'JPWORLDPAY 가입시 입력하신 이메일을 통해 찾을 수 있습니다.',
		text4:
			'JPWORLDPAY 가입시 입력하신 아이디와 이메일을 통해 찾을 수 있습니다.',
		text5: '비밀번호를 변경해 주세요.',
		placeholder1: '이메일을 입력해주세요.',
		placeholder2: '아이디를 입력해주세요.',
		placeholder3: '인증번호를 입력해주세요.',
		placeholder4: '새 비밀번호를 입력해주세요.',
		placeholder5: '새 비밀번호 확인을 입력해주세요.',
	},
	'rtr_auth-register': {
		text1: '매일 수많은 사람들이 이용하는',
		text2: 'JPWORLDPAY와 함께 하세요.',
		text3: '가입을 시작합니다.',
		text4: '서비스 약관에 동의 해 주세요.',
		text5:
			'모든 동의는 필수 및 선택 항목에 대한 동의도 포함되어 있으며, 개별적으로 동의를 선택 할 수 있습니다. 선택 항목에 대한 동의를 거부하시는 경우에도 서비스는 이용이 가능합니다.',
		text6: '모두 동의 합니다.',
		id: '아이디를 입력 하세요.',
		email: '이메일 주소를 입력 하세요.',
		userName: '사용자 이름을 입력 하세요.',
		password: '비밀번호를 입력 하세요.',
		rePassword: '비밀번호를 다시 한 번 입력 하세요.',
		show: '보기',
		agree: '동의',
		signUp: '가입하기',
		cancel: '취소',
		confirm: '확인',
		success: '회원가입이 완료되었습니다.',
		duplicated: '중복된 아이디입니다.',
		required: '(필수)',
		modal: {
			title1: 'JPWORLDPAY 서비스 이용약관',
			text1: '본 이용 약관은 2022년 3월 16일에 모든 사용자에게 적용됩니다.',
			text2: 'JPWORLDPAY에 오신 것을 환영합니다.',
			text3:
				'일본의 JPWORLDPAY 서비스는 국가변경 법인인 JPWORLDPAY Pte. Ltd.가 제공합니다.',
			text4: 'JPWORLDPAY Pte. Ltd.는 일본 금융청에 등록되어 있습니다.',
			text4_1:
				'JPWORLDPAY의 금융청 등록 및 일본의 JPWORLDPAY 서비스에 대한 자세한 내용은 ',
			text5: ' 를 참조하십시오.',
			text6:
				'본 사용자 약관은 일본에서의 고객의 JPWORLDPAY 계정 및 JPWORLDPAY 서비스의 이용에 대해 규정하고 있습니다.',
			text7:
				'고객이 개인인 경우, JPWORLDPAY 계정을 개설하여 JPWORLDPAY 서비스를 이용하기 위해서는 일본 거주자여야 하며 18세 이상이어야 합니다.',
			text8:
				'고객이 사업주 또는 개인 사업주인 경우, JPWORLDPAY 계정을 개설하고 JPWORLDPAY 서비스를 이용하기 위해서는 일본 국내에서 설립 및 운영되고 있거나 일본 거주자여야 합니다.',
			text9:
				'JPWORLDPAY 계정을 개설하여 사용함으로써 귀하는 본 이용 약관의 모든 이용 약관을 준수 할 것에 동의합니다.',
			text10: '또한 귀하는 아래의 추가 페이지, 정책 및 귀하에게 적용되는 ',
			text10_1: ' 페이지에 명시된 기타 각 약관을 준수 할 것에 동의합니다.',
			link1: '일본의 JPWORLDPAY 비즈니스',
		},
	},
	'rtr_auth-dashboard': {
		text1: '인기 자산',
		text2: '즐겨찾는 자산',
		text3: '즐겨찾는 지갑/계좌는 최대 5개 등록이 가능합니다.',
		send: '보내기',
		request: '요청하기',
		history: '거래내역',
		greeting_message: '{user}님의 최종 방문 시간은{date} 입니다.',
	},
	'rtr_pay-payment': {
		title1: '자산 보내기',
		title2: '보내는 방식',
		text1: '계좌번호로 출금',
		text2: '지갑 주소로 출금',
		text3: '오프라인 상점 결제(모바일 전용)',
		text4: '받는 계좌번호',
		text5: '하이픈(-)을 포함하여 입력하세요.',
		text6: '받는 지갑 주소',
		text7: '지갑 주소를 입력하세요.',
		text8: '출금 수량',
		text9: '오프라인 상점 결제',
		text10: '잔여시간',
		text11: '결제 가능 시간이 초과되었습니다.',
		text12: '버튼을 눌러주세요.',
		text13: '코드 재발행 하기',
		caution: '존재하지 않는 계좌번호이거나 유효하지 않은 입력값 입니다.',
		caution2: '존재하지 않는 지갑 주소이거나 유효하지 않은 입력값 입니다.',
		recipient: '받는 사람',
		askWithdraw: '출금 하시겠습니까?',
		scan: 'QR 스캔',
		modal: {
			success: '자산 보내기가 정상적으로 이루어졌습니다.',
			recipient: '받는 사람',
			wallet_account: '지갑 주소',
			payment_amount: '보내는 수량',
			check_info: '출금 정보를 확인해 주세요.',
			account_number: '계좌번호',
		},
	},
	'rtr_pay-deposit': {
		title1: '자산 요청하기',
		title2: '요청하는 방식',
		text1: '계좌 번호로 입금',
		text2: '지갑 주소로 입금',
		text3: '인보이스',
		text4: '받을 계좌번호',
		text5: '받을 지갑 주소',
		text6: '생성된 지갑주소가 없습니다.',
		text7: '요청 정보를 확인해 주세요.',
		text8: '이메일을 입력해 주세요.',
		text9: '품목을 입력해 주세요.',
		text10: '청구금액을 입력해 주세요.',
		my_wallet: '받을 지갑 주소',
		my_account: '받을 계좌 번호',
		email: '이메일을 입력해 주세요.',
		item: '품목을 입력해 주세요.',
		amount: '청구금액을 입력해 주세요.',
		success: '자산 요청이 완료되었습니다.',
	},
	'rtr_pay-exchange': {
		title1: '환전',
		tab1: '구매',
		tab2: '판매',
		text1: '암호자산을 선택하세요.',
		text2: '구매 수량',
		text3: '적용 수량',
		text4: '구매수수료',
		text5: '판매수수료',
		text6: '매매기준율',
		text7: '적용 환율',
		text8: '판매 수량',
		text9: ' 하시겠습니까?',
		text10: '구매할 자산을 선택하세요.',
		text11: '지불할 자산을 선택하세요.',
		text12: '판매할 자산을 선택하세요.',
		text13: '지불 받을 자산을 선택하세요.',
	},
	c2c: {
		buy_list: '구매 목록',
		th1: '판매 자산',
		th2: '가용 수량',
		th3: '가격',
		th4: '지불 자산',
		th5: '상태',
		status1: '전체',
		status4: '취소',
		OPEN: '공시중',
		CANCELED: '취소',
		COMPLETED: '완판',
		PENDING: '미확정',
		PAYED: '홀딩',
		REJECTED: '반려',
		CONFIRMED: '확정',
		escrow_type: {
			BOTH: '매도 공시자 및 매수 요청자 양측이 예치',
			DEALER: '매도 공시자 우선 예치',
			APPLICANT: '매수 요청자 우선 예치',
			DISABLE: '비활성화',
		},
		check: {
			title: '신규 계좌 등록',
			text1: '지갑/계좌를 추가해 주세요.',
			text2: '생성된 계좌가 없습니다.',
			text3:
				'P2P 서비스는 2개 이상의 지갑/계좌를 보유하신 고객만 이용할 수 있습니다',
		},
		search: {
			title: '자산 검색',
			head1: '전체 자산',
			head2: '최근 검색',
			head3: '검색 결과',
			delete: '전체 삭제',
			empty: '검색결과 없음',
		},
		buy: {
			title: '구매 신청',
			title1: '구매 등록시 주의사항',
			head1: '허위 홀딩 금지',
			head2: 'P2P 거래',
			text1:
				'구매자는 반드시 해당 P2P 거래에 대한 지불이 완료된 후에 ‘홀딩’을 클릭하셔야 합니다.',
			text2:
				'허위 홀딩으로 인해 발생하는 판매자와 구매자간의 분쟁은 JPWORLDPAY 에서 책임지지 않습니다.',
			text3:
				'또한 허위 홀딩을 지속적으로 행할 시 서비스 이용에 제한이 가해짐을 유의하시기 바랍니다.',
			text4:
				'지불을 완료한 후에 확정이 되지 않을 경우에는 1대1 문의를 통하여 관리자에게 문의해주시기 바랍니다.',
			text5:
				'외부지갑을 통해 P2P 거래를 할 경우에는 수수료가 부과될 수 있으며 P2P 거래가 정상적으로 이루어지지 않을 경우에는 해당 거래 해결에 대해 불편함이 있을 수 있습니다.',
			text6:
				'P2P 거래는 판매자와 구매자의 자유로운 거래 활동을 기반으로 합니다.',
			text7:
				'JPWORLDPAY 는 판매자와 구매자의 편리하고 안전한 거래를 위한 플랫폼 서비스만을 제공합니다.',
			text8:
				'판매자와 구매자간의 법적 분쟁이 발생했을 시 JPWORLDPAY 는 에스크로의 역할로서만 책임을 지는 점 유의하시기 바랍니다.',
			head3: '구입할 자산',
			head4: '총 판매 수량',
			head5: '개당 판매 가격',
			head6: '가용 수량',
			head7: '보유',
			head8: '구매 수량',
			head9: '수수료',
			head10: '지불할',
			head11: '수량',
			head12: '지불 계좌',
			text9: '수수료액',
			text10: ' 만큼 차감 됩니다.',
		},
		sell: {
			title: '판매 등록',
			title1: '핀매 등록시 주의사항',
			head1: '허위 공시 금지',
			head2: '확정 버튼 클릭 시 주의사항',
			head3: '확정 버튼을 누르지 않았을 시',
			head4: 'P2P거래',
			text1:
				'판매자는 반드시 판매에 필요한 암호자산을 충분히 보유한 후 거래를 하시기 바랍니다.',
			text2:
				'허위공시를 지속적으로 행할시 서비스 이용에 제한이 가해짐을 유의하시기 바랍니다.',
			text3:
				'판매자는 구매자의 지불을 반드시 확인한 후에 ‘확정’ 버튼을 클릭하셔야 합니다.',
			text4:
				'판매자의 부주의로 인해 발생하는 금전적 손해에 대해서 JPWORLDPAY 는 법적으로 책임이 없습니다.',
			text5: '반드시 구매자의 지불여부를 확인해주십시오.',
			text6:
				'판매자는 구매자의 지불여부를 확인한 후 반드시 ‘확정’버튼을 클릭하셔야 합니다.',
			text7:
				'‘확정’버튼을 클릭하지 않았을 시 관리자에 의해 서비스 이용에 제한이 가해짐을 유의해 주시기 바랍니다.',

			text8:
				'P2P 거래는 판매자와 구매자의 자유로운 거래 활동을 기반으로 합니다.',
			text9:
				'JPWORLDPAY 는 판매자와 구매자의 편리하고 안전한 거래를 위한 플랫폼 서비스만을 제공합니다.',
			text10:
				'판매자와 구매자간의 법적 분쟁이 발생했을 시 JPWORLDPAY 는 에스크로의 역할로서만 책임을 지는 점 유의하시기 바랍니다.',
			text11: '수수료',
			placeholder1: '판매할 자산을 선택하세요.',
			placeholder2: '지불 받을 자산을 선택하세요.',
			head5: '판매 수량',
			head6: '최소 구매 수량',
			head7: '스프레드 비율',
			head8: '개당 판매 가격',
		},
	},
	'rtr_pay-contact': {
		search: '검색',
		bookmark: '즐겨찾기',
		name: '이름',
		account: '계좌번호',
		memo: '메모',
		location: '위치',
		status: '프로필 상태',
		text1: '모든 사람이 고객님의 JPYS 계좌번호를',
		text2: '검색 및 입금 하실 수 있습니다.',
	},
	'rtr_pay-invoice': {
		title1: '청구대상',
		input1: '이메일',
		title2: '품목',
		input2: '상품이름',
		title3: '받을 암호자산',
		title4: '지불 기일',
		title5: '총계',
		text1: '요청 하시겠습니까?',
	},
	'rtr_mypage-account': {
		title: '계정',
		name: '이름',
		email: '이메일',
		password: '비밀번호',
		new_password1: '새 비밀번호',
		new_password2: '새 비밀번호 확인',
	},
	'rtr_mypage-data': {
		title1: '보안',
		text1:
			'"Google Authenticator" 앱을 스마트폰 또는 데스크톱에 설치해 주세요.',
		text2:
			'안드로이드 또는 iPhone, iPad 그리고 iPod, Windows Phone, 그리고 Microsoft Windows desktop을 포함한 기타',
		text3: ' 다른 시스템 .',
		text4: '이 키를',
		text5:
			'종이에 적어 주세요. 단말을 잃어버리거나 OTP를 변경해야 할 때 사용됩니다.',
		text6:
			'"Google Authenticator" 앱을 실행하시고 화면 아래의 Scan QR barcode을 탭해 주세요.',
		text7:
			'단말의 화면에 표시된 인증코드를 아래의 "인증코드" 란에 입력해 주세요.',
		text8: 'OTP 키',
		text10: 'OTP 키',
		text11: '(OTP 활성화를 하려면 아래 인증번호를 입력하세요.)',
		text12: '인증번호를 입력하세요.',
		text13: 'OTP 비활성화를 하려면 아래 인증번호를 입력하세요.',
	},
	'rtr_wallet_account-assets': {
		title1: '자산 목록',
		title2: '지갑/계좌',
		title3: '계좌 등록',
		tab1: '자산',
		tab2: '즐겨찾기',
		empty: '선택된 자산이 없습니다.',
		text1: '즐겨찾는 지갑/계좌는 최대 5개 등록이 가능합니다.',
		text2: '지갑/계좌를 추가해 주세요.',
		account: '계좌',
		address: '지갑',
	},
	'account-wallet': {
		title1: '나의 지갑',
		title2: '나의 계좌',
		btn_charge: '충전하기',
		btn_jpys_send: '이체하기',
		btn_other_send: '출금하기',
		btn_receive: '입금받기',
		text1: 'JPYS가 없어도 결제 및 JPWORLDPAY를 사용 할 수 있습니다.',
		my_wallet: '나의 지갑 주소',
		my_account: '나의 계좌 번호',
		btn_copy: '복사하기',
		modal: {
			title1: '전기통신 금융사기 피해예방을 위한 한도제한 안내',
			text1:
				'암호자산이 비대면으로 개설되면서 자동화기기, 인터넷을 통한 인출(이체)한도가 있습니다.',
			text2:
				'거래목적을 확인 할 수 있는 객관적 인증자료를 제시하시기 바랍니다.',
			text3: "'설정'에서 한도제한을 해제 할 수 있습니다.",
			title2: '유의사항',
			text4:
				'인터넷뱅킹 가입은 입출금 계좌를 개설 하신 후 완료화면에서 연동하여 신청 할 수 있습니다.',
			caution:
				'인터넷뱅킹으로 이체거래를 보다 더 간편하게 진행하시려면 보안 인증을 거치셔야합니다. 인증 과정을 통하여 등급을 향상 시킨 후 출금한도 및 이체한도를 올리시기 바랍니다.',
			text5:
				'신규가입 버튼을 클릭하면 회원님 고유의 (암호자산) JPWORLDPAY 전용계좌 및 외부 지갑 연동 입금주소가 발급됩니다.',
			text6:
				'입금 전 꼭 알아두세요! JPWORLDPAY 계좌에서 계좌로 송금하면 최저가 수수료 또는 무료 일 수 있습니다.',
			text7:
				'신규가입시 발행되는 계좌/지갑 주소로는 (암호자산) 입금만 가능합니다. 해당 주소로 다른 디지털 자산을 입금 시도 할경우에 발생 할 수 있는 오류/손실은 복구 불가능합니다.',
			text8:
				'1번의 확인이 발생한 이후, 입금 프로세스를 거쳐 잔고에 반영됩니다.',
			text9:
				'입금 프로세스는 자동으로 진행되며 네트워크 상황에 따라 소요시간이 달라 질 수 있습니다. 위 주소는 입금전용 주소입니다.',
			text10:
				'회원님에게 할당 된 신규가입으로는 (암호자산) 을 입금할 수 있습니다.',
			check1: '위 사항을 동의 및 숙지 하셨습니까?',
		},
	},
	rtr_activity: {
		title: '거래 내역',
		start: '시작',
		end: '종료',
		search: '활동 검색',
		button1: '명세서',
		select: '선택해주세요',
		text1: '아직 거래가 없습니다.',
		text2: '시작과 종료 날짜를 지정해서 다시 시도해 보시기 바랍니다.',
		withdrawal: '출금',
		deposit: '입금',
		type: '구분',
		registration_date: '등록일',
		asset_name: '자산명',
		sender: '보낸 사람',
		recipient: '받은 사람',
		amount: '이체금액',
		w_account: '출금 계좌번호',
		d_account: '입금 계좌번호',
		w_address: '출금 지갑 주소',
		d_address: '입금 지갑 주소',
		detail: '거래내역 상세',
		text3: '보낸 수량',
		text4: '입금 계좌번호',
		text5: '받은 자산',
		text6: '받은 수량',
		text7: '출금 계좌번호',
		text8: '보낸 자산',
		account: '계좌',
		wallet: '지갑',
		check_all: '전체 선택',
		account_number: '계좌번호',
		empty: '등록된 거래 내역이 없습니다.',
	},
	'rtr_activity-exchange': {
		title1: '환전 내역',
		tab1: '전체 내역',
		tab2: '구매 내역',
		tab3: '판매 내역',
		th1: '구분',
		th2: '등록일시',
		th3: '기준 자산 수량',
		th4: '적용 자산 수량',
		th5: '적용 매매기준율',
		th6: '적용 스프레드율',
		th7: '적용 환율',
		buy: '구매',
		sell: '판매',
		empty: '등록된 환전 내역이 없습니다.',
		detail: {
			title1: '환전 내역 상세',
			th1: '구매 자산',
			th2: '적용 자산',
			th3: '구매 자산 수량',
			th5: '구매 자산 계좌번호',
			th6: '적용 자산 계좌번호',
			th10: '교환 타입',
			th11: '신청일',
			th12: '판매 자산',
			th13: '판매 자산 수량',
			th14: '판매 자산 계좌번호',
		},
	},
	'rtr_activity-c2c': {
		title1: 'P2P내역',
		title2: '구매 내역 상세',
		title3: '판매 현황',
		title4: '판매 현황 상세',
		tab1: '구매 내역',
		tab2: '판매 내역',
		purchased_asset: '구매 자산',
		purchase_quantity: '구매 수량',
		purchase_price: '구매 가격',
		payment_asset: '지불 자산',
		total_fee: '수수료 합계',
		account_number: '상대방 계좌번호',
		status: '상태',
		application_date: '신청일시',
		registration_date: '등록일시',
		closing_date: '종결 일시',
		amount_paid: '지불 금액',
		deposit_amount: '입금 금액',
		sold_asset: '판매 자산',
		registered_quantity: '등록 수량',
		sold_price: '판매 가격',
		sold_quantity: '판매 수량',
		safety_type: '구매 안전 유형',
		min_purchase_quantity: '최소 구매 수량',
		available_quantity: '가용 수량',
		confirmed_sales_quantity: '확정 판매 수량',
		unconfirmed_sales_quantity: '미확정 판매 수량',
		charge_fee: '매도 공시자 부과 수수료',
		empty: '등록된 P2P 구매 내역이 없습니다.',
		empty2: '등록된 P2P 판매 내역이 없습니다.',
	},
	'rtr_activity-invoice': {
		title: '인보이스 내역',
		target: '청구대상',
		request_asset: '요청한 자산',
		request_amount: '요청 수량',
		item: '품목',
		due_date: '지불 기일',
		empty: '등록된 인보이스 내역이 없습니다.',
	},
	auth: {
		id: 'ID를 입력하세요.',
		password: '비밀번호를 입력하세요.',
		login_btn: '로그인',
		signup_btn: '가입하기',
		or: '또는',
	},
	banner1: {
		text1: '지갑/계좌가 없으신가요?',
		text2: '가장 안전하고 빠르게 만들 수 있는',
		text3: 'JPWORLDPAY 지갑/계좌를 지금 무료로',
		text4: '만들어 보세요.',
		text5: '지금 무료로 만들어보세요!',
	},
	banner2: {
		text1: '서비스 운영시간',
		text2: '(24시간 문의 가능)',
		text3: '온라인 뱅크 운영시간',
		text4: '24시 연중무휴',
		text5: '(23:30-24:00 이용불가)',
		text6: '오프라인 뱅크 운영시간',
		text7: '(주말 및 공휴일 휴무)',
	},

	account_register: {
		title1: '전기통신 금융사기 피해예방을 위한 한도제한 안내',
		text1:
			'요구불계좌가 비대면으로 개설되면서 자동화기기, 인터넷을 통한 인출(이체) 한도는 1일 {0} JPYS로 제한됩니다.',
		text2:
			'거래목적을 확인 할 수 있는 객관적 인증자료를 지점에 제시 및 “관리 > 보안 인증/관리”에서 한도제한을 해제할 수 있습니다.',
		text3: '인터넷뱅킹 이용 시 출금계좌로 등록해야 이체거래를 할 수 있습니다.',
		text4: '암호자산별 한도제한 계좌는 1인당 5개만 개설할 수 있습니다.',
		title2: '유의사항',
		text5:
			'- 인터넷뱅킹 가입은 입출금계좌를 개설 하신 후 완료화면에서 연동하여 신청 할 수 있습니다.',
		text6:
			'- 기존 인터넷뱅킹 가입 고객은 출금계좌 등록구분이 인터넷+지점으로 되어 있을 때만 인터넷 뱅킹으로 출금계좌 등록을 할 수 있음을 유의해주세요.',
		text7:
			'* 인터넷뱅킹으로 이체거래를 보다 더 간편하게 진행하시려면 보안 인증을 거치셔야합니다. 인증 과정을 통하여등급을 향상 시킨 후 출금한도및 이체한도를 올리시기 바랍니다.',
		title3:
			'신규가입 버튼을 클릭하면 회원님 고유의 { title } JPWORLDPAY 전용계좌 및 외부 지갑 연동 입금주소가 발급됩니다.',
		text8:
			'입금 전 꼭 알아두세요! JPWORLDPAY 계좌에서 계좌로 송금하면 최저가 수수료 또는 무료 일 수 있습니다.',
		text9:
			'신규가입시 발행되는 계좌/지갑 주소로는 { title } 입금만 가능합니다.',
		text10:
			'해당 주소로 다른 디지털 자산을 입금 시도 할 경우에 발생 할 수 있는 오류/ 손실은 복구 불가능합니다.',
		text11: '1번의 확인이 발생한 이후, 입금 프로세스를 거쳐 잔고에 반영됩니다.',
		text12:
			'입금 프로세스는 자동으로 진행되며 네트워크 상황에 따라 소요시간이 달라질 수 있습니다. 위 주소는 입금전용 주소입니다.',
		text13:
			'회원님에게 할당 된 신규가입으로는 { title } 을 입금할 수 있습니다.',
		agree: '위 사항을 동의 및 숙지 하셨습니까?',
		title4: '계좌 고유 번호',
		title5: '계좌 번호',
		title6: '계좌 이름',
		text14: '계좌 이름을 입력 하세요.',
		title7: '정지금액',
		title8: '상태',
		title9: '선택 자산',
		text15: '자동으로 입력 됩니다.',
		title10: '생성 된 계좌번호',
		text16: 'JPWORLDPAY 전용 계좌번호',
	},
	merchant: {
		picker: {
			title1: '관리 할 가맹점을 선택하세요.',
			title2: '가맹점 등록',
			success_shop_register: '가맹점이 등록되었습니다.',
			insert_shop_name: '가맹점 이름을 입력해주세요.',
			insert_shop_id: '가맹점 ID를 입력해주세요.',
			merchant_name: '가맹점 이름',
			merchant_id: '가맹점 ID',
			regist_date: '등록일',
		},
		transaction: {
			text1: '결제내역',
			text2: '아직 거래가 없습니다.',
			text3: '시작과 종료 날짜를 지정해서 다시 시도해 보시기 바랍니다.',
			text4: '결제내역 상세',
			empty: '등록된 결제 내역이 없습니다.',
			total_count: '총 결제건',
			total_amount: '총 결제금액',
			count: ' 건',
			table: {
				time: '결제시간',
				name: '결제 명',
				id: '결제 ID',
				payer: '결제자 명',
				type: '결제 유형',
				status: '상태',
				amount: '결제금액',
				order_no: '상점 주문 번호',
			},
		},
		settlement: {
			title: '정산 계좌 관리',
			title1: '정산 계좌 연결',
			title2: '정산 계좌 연결 해지',
			date: '등록일',
			asset_name: '자산명',
			account: '계좌번호',
			no_content: '연결된 정산 계좌가 없습니다.',
			select: '암호자산을 선택하세요.',
			name: '가맹점 이름',
			id: '가맹점 ID',
			asset: '정산 계좌',
			connect: '정산 계좌 연결',
			disconnect: '해지',
			set_disconnect: '연결 계좌 해지',
			disconnect2: '정산 계좌 연결이 해지되었습니다.',
		},
		title1: '결제 통계',
		title2: '정산달력',
		title3: '퀵메뉴',
		title4: '공지사항',
		title5: '고객센터',
		title6: '인증 관리',
		menu1: '상점정보',
		menu2: '정산 계좌 관리',
		menu3: '1:1 문의',
		menu4: '문의 내역',
		menu5: '이메일 인증',
		menu6: 'OTP 인증',
		menu7: '보안등급',
		menu_2: {
			menu1: '공지사항',
			menu2: '1:1 문의',
			menu3: '문의 내역',
			menu4: '자주 묻는 질문',
			menu5: 'KYC 인증',
			menu6: '이메일 인증',
			menu7: 'OTP 인증',
			menu8: '출금주소 인증',
			menu9: '보안등급',
		},
		inquiry: {
			text1: '문의 유형을 선택 해 주세요.',
			text2: '제목을 입력하세요.',
			text3: '문의 내용을 입력하세요.',
			text4: '문의유형',
			text5: '제목',
			text6: '문의일',
			text7: '상태',
			text8: '답변대기',
			text9: '답변완료',
			text10: '등록된 내용이 없습니다.',
			text11: '문의 작성하신 내용이',
			text12: '정상적으로 접수 완료',
			text13: '되었습니다.',
		},
		kyc: {
			text1: '회원 고유 번호',
			text2: '사용자 이름',
			text3: '이메일',
		},
		email: {
			link1: '인증 코드 재전송',
		},
		otp: {
			text1:
				'"Google Authenticator" 앱을 스마트폰 또는 데스크톱에 설치해 주세요.',
			text2:
				'안드로이드 또는 iPhone, iPad 그리고 iPod, Windows Phone, 그리고 Microsoft Windows desktop을 포함한 기타 다른 시스템.',
			text3: '이 키를 ',
			text4:
				' 종이에 적어 주세요. 단말을 잃어버리거나 OTP를 변경해야 할 때 사용됩니다.',
			text5:
				'"Google Authenticator" 앱을 실행하시고 화면 아래의 Scan QR barcode을 탭 해 주세요.',
			text6:
				'단말의 화면에 표시된 인증코드를 아래의 "인증코드" 란에 입력해 주세요.',
			text7: 'OTP 키',
			text8: 'OTP 키 (OTP 활성화를 하려면 아래 인증번호를 입력하세요.)',
			text9: '인증번호를 입력하세요.',
		},
		address: {
			select: '선택없음',
			text1: '자산 선택',
			text2: '자산 주소',
			text3: '자산 주소를 입력하세요.',
			text4: '이미 인증이 완료된 자산입니다.',
			text5: '뱅크 선택',
			text6: '예금주 명',
			text7: '계좌번호',
			text8: '생일',
			text9: '생년월일 6자리',
			register: '등록하기',
			alert: '출금주소 인증이 완료되었습니다.',
		},
		security: {
			authStatus: {
				ok: '인증완료',
				no: '인증하기',
			},
			level1: 'Level 1',
			level2: 'Level 2',
			level3: 'Level 3',
			level4: 'Level 4',
			email: '이메일 인증',
			kyc: 'KYC 인증',
			otp: 'OTP 인증',
			address: '출금 주소 인증',
			title1: '회원고유번호',
			title2: '유저명',
			title3: '제한사항',
			text1: '자산 1회 출금 금액 제한',
			text2: '100 ETH',
			text3: '자산 1일 출금 금액 제한',
			text4: '1,000 ETH',
			text5: '자산 1회 출금 금액 제한',
			text6: '10 BTC',
			text7: '자산 1일 출금 금액 제한',
			text8: '1,000 BTC',
			placeholder: '이메일 주소를 입력하세요.',
			placeholder1: '인증코드를 5분 이내에 입력해 주세요.',
		},
		info1: '님의 보안등급은',
		info2: 'Level',
		info3: '입니다.',
	},
	input: {
		placeholder: {
			search: '검색',
			select_assets: '자산을 선택하세요.',
			search_assets: '자산을 검색하세요.',
			search_activity: '활동 검색',
			email: '이메일 주소를 입력하세요.',
			code_request: '인증코드를 입력 해 주세요.',
			inquiry_type: '문의 유형을 선택 해 주세요.',
			enter_subject: '제목을 입력하세요.',
			inquiry_content: '문의 내용을 입력하세요.',
			password: '비밀번호를 입력하세요.',
			all_assets: '전체 자산',
		},
		label: {
			email: '이메일',
			password: '비밀번호',
			inquiry_type: '문의 유형',
			enter_subject: '제목',
			inquiry_content: '문의 내용',
		},
	},
	select: {
		select: '선택해주세요.',
		all: '전체',
	},
	button: {
		add: '추가',
		delete: '삭제',
		cancel: '취소',
		change: '변경',
		pay: '결제하기',
		next: '다음',
		back: '뒤로',
		request: '요청하기',
		send: '보내기',
		close: '닫기',
		do_not_look: '다시보지않기',
		confirm: '확인',
		signup: '회원가입하기',
		down: '앱 다운로드',
		edit: '수정',
		edit1: '편집',
		delete_account: '계정 탈퇴',
		code: '인증 코드 발송',
		code_check: '인증 코드 확인',
		code_completed: '인증 완료',
		otp: 'OTP 활성화',
		otp_disabled: 'OTP 비활성화',
		asset_send: '자산보내기',
		cryptocurrency_request: '암호화폐 요청',
		membership_withdrawal: '회원 탈퇴',
		info: '영업팀에 문의',
		share: '공유',
		new_account: '신규가입',
		open_account: '개설',
		search: '검색',
		start: '시작하기',
		register: '등록',
		list: '목록',
		inquiry_list: '문의 내역으로',
		check_balance: '잔액 확인',
		sales: '판매 등록',
		purchase: '구매 등록',
		withdraw: '출금',
		copy: '복사하기',
		detail: '상세',
		payment: '지불',
		decide: '확정',
		check: '조회',
		reject: '거부',
		application: '신청',
		connect: '연결',
		not_see_today: '오늘 하루 보지 않기',
		receive_request: '받기요청',
		block: '차단',
		more: '더보기',
	},
	modal: {
		message: {
			select_asset: '자산을 선택해 주세요.',
			select_way: '출금방식을 선택해 주세요.',
			check_account: '수취인 계좌를 확인해 주세요.',
			check_address: '수취 지갑 주소를 확인해 주세요.',
			set_amount: '이체금액을 입력해 주세요.',
			need_agree: '동의하셔야 신규가입을 할 수 있습니다.',
			no_account: '생성된 계좌가 없습니다.',
			set_otp: 'OTP 활성화가 완료되었습니다.',
			deactivation_otp: 'OTP 비활성화가 완료되었습니다.',
			set_code: '인증번호를 입력해 주세요.',
			set_buy: '구매 하시겠습니까?',
			registered: '등록되었습니다.',
			set_sell: '판매 하시겠습니까?',
			success_exchange: '환전이 정상적으로 처리되었습니다.',
			success_withdraw: '출금이 완료되었습니다.',
			success_confirm: '확정이 정상적으로 처리되었습니다.',
			success_cancel: '취소가 정상적으로 처리되었습니다.',
			success_payment: '지불이 정상적으로 처리되었습니다.',
			success_reject: '거부가 정상적으로 처리되었습니다.',
			set_cancel: '취소 하시겠습니까?',
			set_pay: '지불 하시겠습니까?',
			set_confirm: '확정 하시겠습니까?',
			set_reject: '거부 하시겠습니까?',
			sent_id: '작성하신 메일로 아이디가 발송되었습니다.',
			sent_authCode: '작성하신 메일로 인증번호가 발송되었습니다.',
			pw_changed: '비밀번호가 변경되었습니다.',
			settlement_connect: '정산 계좌가 연결되었습니다.',
			settlement_disconnect: '정산 계좌를 해지하시겠습니까?',
			settlement_disconnect2: '정산 계좌 연결이 해지되었습니다.',
			merchant_regist_confirm: '가맹점 등록이 완료되었습니다.',
			complete_payment: '결제가 완료되었습니다.',
		},
		account: {
			status1: '변경 할 항목을 입력해주세요.',
			status2: '계정정보가 변경되었습니다.',
			status3: '회원탈퇴가 완료되었습니다.',
			status4: '계정을 삭제하시겠습니까?',
			status5: '회원 이름을 입력해주세요.',
			status6: '비밀번호를 입력해주세요.',
			status7: '새 비밀번호를 입력해주세요.',
			status8: '새 비밀번호 확인을 입력해주세요.',
			status9: '새 비밀번호와 비밀변호 확인이 일치하지 않습니다.',
		},
		history: '이체내역',
	},
	alert: {
		request_id: '아이디를 입력 해 주세요.',
		request_pw: '비밀번호를 입력 해 주세요.',
		request_check_term: '필수약관에 동의 해 주세요.',
		transaction_check: '거래내역을 체크해 주세요.',
		not_yet: '준비중 입니다.',
		copy_s: '복사되었습니다.',
		copy_f: '복사가 실패했습니다.',
		logout: '로그아웃 하시겠습니까?',
		enter_email: '이메일 주소를 입력해 주세요.',
		enter_authCode: '인증번호를 입력해주세요.',
		enter_newPw: '새 비밀번호를 입력해 주세요.',
		enter_newPwConfirm: '새 비밀번호 확인을 입력해 주세요.',
		wrong_newInfo: '새 비밀번호와 비밀번호 확인이 일치하지 않습니다.',
	},
	help: {
		title: '도움말',
		title1: '일반 질문',
		q1: '활동이 표시되지 않음',
		a1: '검색 기록, 방문한 웹사이트, 기타 활동이 내 활동에 표시되지 않는 경우 다음을 확인하시기 바랍니다.',
		q2: '알 수 없는 활동이 있음',
		a2: '내 활동에 다음과 같이 알 수 없는 유형의 활동이 표시될 수 있습니다.',
		q3: '개인 정보 보호를 위한 추천 설정 검토',
		a3: '자동 삭제 옵션을 설정하여 활동 저장 기간을 관리할 수 있습니다.',
		q4: '개인 정보 보호 설정 확인하기',
		a4: '개인 정보 보호 진단을 통해 아래 설명된 대부분의 설정을 간편하게 확인하고 변경할 수 있습니다.',
		q5: '저장할 활동 제어하기',
		a5: '활동 제어 설정에서 계정에 저장되는 활동 유형을 선택할 수 있습니다. 다음과 같은 활동이 포함됩니다.',
		q6: '정보 추적 및 삭제하기',
		a6: '다음 리소스는 Google 계정에 저장되는 활동을 검토하고 제어하는 데 도움이 됩니다.',
		q7: '데이터 개요 확인하기',
		a7: 'Google 대시보드를 방문하여 Gmail, Drive, Calendar 등 여러 Google 서비스의 데이터 요약을 확인해 보세요.',
		q8: '활동/파일 확인 및 삭제하기',
		a8: '다음과 같은 관련 Google 제품에서 사진, 이메일, 문서 등의 파일을 확인하고 삭제할 수 있습니다.',
		q9: '내 활동',
		a9: '내 활동에서 검색 기록 및 방문한 웹사이트와 같은 활동을 확인하고 삭제하세요.',
		q10: '방문한 장소 확인 및 삭제하기',
		a10: '위치 기록을 사용 설정하면 방문한 장소가 계정에 저장됩니다. 내 위치 기록은 나만 볼 수 있습니다.',
		q11: '추가 정보',
		a11: '다음 리소스에서 내 데이터와 Google에서 내 데이터를 사용하는 방식을 자세히 알아보세요.',
		q12: '저장되는 활동 변경하기',
		a12: '이 설정을 변경하여 계정에 저장되는 활동을 대부분 제어할 수 있습니다.',
		q13: '활동 확인 또는 삭제하기',
		a13: 'Google 계정으로 이동합니다.',
		q14: '활동이 저장되는 경우',
		a14: '휴대전화에서 Google 계정에 로그인하면 활동이 저장됩니다. 활동 제어가 사용 설정된 경우 Google은 이 설정에 따른 정보를 저장할 수 있습니다.',
		q15: '활동 삭제 방법',
		a15: '활동을 수동으로 삭제하거나 자동 삭제 설정에 따라 자동으로 삭제하면 해당 제품과 Google 시스템에서 즉시 삭제 절차가 시작됩니다.',
		q16: '내 활동이란 무엇인가요?',
		a16: '내 활동은 내가 한 검색, 방문한 웹사이트, 시청한 동영상 등의 활동을 확인하고 관리할 수 있는 장소입니다.',
		q17: '활동 찾기 및 보기',
		a17: '내 활동은 개별 항목으로 나열되며, 가장 최신 활동부터 표시됩니다.',
		q18: '활동 삭제하기',
		a18: '내 활동에서 과거 검색 기록, 방문 기록 및 기타 활동을 삭제하는 방법을 알아보세요. 이전 활동이 자동 삭제되도록 설정할 수도 있습니다.',
		q19: '관리자 또는 서비스 제공업체의 데이터 액세스',
		a19: '계정을 통해 제출하거나 업로드하는 데이터 또는 콘텐츠의 소유자',
		q20: '세이프서치 문제 해결하기',
		a20: '세이프서치가 작동하지 않는 경우 세이프서치 문제를 해결하는 방법을 알아보세요.',
		q21: '선정적인 콘텐츠 신고하기',
		a21: '세이프서치 사용 중에 선정적인 콘텐츠를 발견한 경우 콘텐츠를 신고해 주시기 바랍니다.',
	},
	popup: {
		title1: '클로즈 베타 테스트 ',
		title2: 'JANO 서포터즈',
		title3: ' 모집!',
		period: '클로즈 베타기간 2022년 11월 23일 ~ 12월 23일',
		text1: 'JPWORLDPAY 클로즈 베타 테스트에 JANO 서포터즈 여러분을 초대합니다.',
		text2: 'JPWORLDPAY 의 첫번째 서비스인 블록체인 기반의 PAY 플랫폼',
		text3: 'JPWORLDPAY 를 미리 만나보시기 바랍니다.',
		m_text1: 'JPWORLDPAY 클로즈 베타 테스트에',
		m_text2: '여러분을 초대합니다.',
		m_text3: '클로즈 베타기간',
		m_text4: '2022년 11월 23일',
		m_text5: '~12월 23일',
	},
	tutorial: {
		dashboard: {
			step1_title: '인기자산',
			step1_text: 'JPWORLDPAY에서 추천하는 인기 자산입니다.',
			step2_title: '보내기',
			step2_text: '버튼을 탭(터치)해서 자산을 보내세요.',
			step3_title: '요청하기',
			step3_text: '버튼을 탭(터치)해서 자산을 요청하세요.',
			step4_title: '거래내역',
			step4_text: '자산을 보내고 받은 내역을 확인하세요.',
			step5_title: '즐겨찾는 지갑/계좌',
			step5_text:
				'다음 아이콘과 동일한 버튼을 탭(터치)하면 즐겨찾는 자산을 설정할 수 있어요.',
			step6_title: '지갑/계좌 만들기',
			step6_text: '다양한 자산을 추가해서 더 많은 서비스를 경험하세요.',
		},
		payment: {
			step1_title: '보내는 자산',
			step1_text: '보낼 수 있는 자산을 확인하고 선택하세요.',
			step2_title: '보내는 방식',
			step2_text: '세가지 방식으로 자산을 보낼 수 있습니다.',
			step3_title: '1. 오프라인 상점 결제',
			step3_text: 'JPWORLDPAY 가맹점에서 QR코드로 간편하게 결제하세요.',
			step4_title: '2. 계좌 번호로 출금',
			step4_text: 'JPWORLDPAY 사용자에게 계좌 번호로 자산을 보내세요.',
			step5_title: '3. 지갑 주소로 출금',
			step5_text: '지갑 주소로 JPYS와 암호자산을 보내세요.',
		},
		deposit: {
			step1_title: '요청하는 자산',
			step1_text: '요청할 수 있는 자산을 확인하고 선택하세요.',
			step2_title: '요청하는 방식',
			step2_text: '세가지 방식으로 자산을 요청할 수 있습니다.',
			step3_title: '1. 계좌 번호로 입금',
			step3_text: 'JPWORLDPAY 사용자에게 계좌 번호로 자산을 요청하세요.',
			step4_title: '2. 지갑 주소로 입금',
			step4_text: '지갑 주소로 자산을 요청하세요.',
			step5_title: '3. 인보이스',
			step5_text: '청구서를 보내 자산을 요청하세요.',
		},
		exchange: {
			step1_title: '구매/판매',
			step1_text: 'JPWORLDPAY에서 제안하는 환전 방식으로 자산을 교환하세요.',
		},
		c2c: {
			step1_title: '판매등록',
			step1_text: '다른 JPWORLDPAY 사용자에게 내가 가진 자산을 판매하세요.',
			step2_title: '목록 갱신',
			step2_text:
				'아이콘 버튼을 탭(터치)해서 현재 판매중인 모든 목록을 확인하세요.',
			step3_title: '구매 신청',
			step3_text: '원하는 판매건을 선택해서 구매를 신청하세요.',
		},
	},
	underConstruction: '지금은 준비중입니다. 빠른 시간 내에 보여드리겠습니다.',
	menu: {
		dashboard: '대시보드',
		company: '기업',
		personal: '개인',
		'personal-how': '쇼핑 및 구매 방법',
		'personal-how-online_shopping': '온라인 쇼핑',
		'personal-how-offline_kiosk': '오프라인 키오스크',
		'personal-how-qr': 'QR코드로 결제',
		'personal-how-janopay_creditcard': 'JPWORLDPAY 신용카드',
		'personal-how-trade_and_cashback': '거래 및 캐시백',
		'personal-request': '보내기 및 받기',
		'personal-request-send': '자산 보내기',
		'personal-request-receive': '자산 요청',
		'personal-request-deposit': '입금 받기',
		'personal-request-commission': '수수료',
		'personal-asset': '자산 관리',
		'personal-asset-wallet': '지갑',
		'personal-asset-account': '계좌',
		'personal-asset-jpys': 'JPYS 추가',
		'personal-asset-sale': '판매하기',
		'personal-asset-exchange': '환전하기',
		business: '비즈니스',
		'business-how': '시작 방법',
		'business-how-start': '시작하기',
		'business-how-solution': '솔루션',
		'business-how-receive': '지불 수락',
		'business-how-pay': '결제하기',
		'business-how-risk': '위험 관리',
		'business-operation': '운영 방법',
		'business-operation-corps': '기업에 관해',
		'business-operation-platform': '플랫폼 및 기능',
		'business-operation-pay': '지불 방법',
		'business-operation-global': '글로벌 결제 처리',
		'business-asset': '자산 관리',
		'business-asset-pay': '지불 방법',
		'merchant-console-catalog': '상점 정보',
		'merchant-console-transaction-list': '결제 내역',
		'merchant-console-settlement_account': '정산 계좌 관리',
		'merchant-console-cs-notice': '고객센터',
		'merchant-console-certification-kyc': '인증/관리',
		development: '개발',
		cs: '고객센터',
		notice: '공지사항',
		inquiry: '1:1 문의',
		inquiry_detail: '문의 내역',
		faq: '자주 묻는 질문',
		pay: '자산 관리',
		'pay-payment': '자산 보내기',
		'pay-deposit': '자산 요청하기',
		'pay-exchange': '환전',
		'pay-c2c': 'P2P',
		'pay-contacts': '연락처',
		'pay-invoice': '인보이스',
		wallet_account: '지갑/계좌',
		'wallet_account-wallet': '지갑 열기',
		'wallet_account-account': '계좌 열기',
		'wallet_account-assets': '전체 자산',
		activity: '활동 내역',
		'activity-transaction': '거래 내역',
		'activity-exchange': '환전 내역',
		'activity-c2c': 'P2P 내역',
		'activity-invoice': '인보이스 내역',
		help: '도움말',
		setting: '설정',
		'setting-security': '보안',
		'setting-payment': '결제하기',
		'setting-notice': '알림',
		mypage: '마이페이지',
		merchant: {
			merchant: '가맹점',
			personal: '개인',
			information: '가맹점 정보',
			payment_history: '결제 내역',
		},
		'mypage-account': '계정',
		'mypage-data': '데이터',
		'mypage-certification': '인증/관리',
		'mypage-seller_tool': '판매자 도구',
		logout: '로그아웃',
		login_text1: '로그인하여',
		login_text2: '더 많은 정보를 확인해 보세요.',
	},
	merchant_management: {
		menu: '메뉴',
		title: {
			qr_payment: 'QR 스캔',
			payment_list: '결제 내역',
			merchant_management: '가맹점 관리',
			account: '계정',
			setup: '설정',
		},
		merchant_list: '님의 가맹점 목록',
		account_number: '계좌번호',
		qr_payment: {
			deal_name: '거래 명칭',
			title: 'QR 결제',
			payer: '결제자',
			check_payment_information: '결제 정보를 확인 해 주세요.',
			payment: '결제',
			complete_payment: '결제가 완료되었습니다.',
			payment_asset: '결제 자산',
			payment_name: '결제 내용',
			amount: '결제 금액',
		},
		payment_list: {
			login: '로그인',
			forgot: '아이디/비밀번호 찾기',
			qr_scan: 'QR 코드를 스캔 해 주세요.',
			merchant_selection: '가맹점 선택',
			count: ' 건',
			order_number: '주문번호',
			detail: {
				total_payment: '총 결제건',
				total_amount: '총 결제금액',
				complete_payment: '결제완료',
				refund: '환불',
				no_payment_count: '해당 날짜의 결제건이 없습니다.',
				merchant_name: '가맹점 명',
				payment_assets: '결제 자산',
				payment_date: '결제 일시',
				refund_date: '환불 일시',
				check_refund_information: '환불 정보를 확인 해 주세요.',
				refund_complete: '환불이 완료되었습니다.',
			},
			table: {
				time: '결제시간',
				name: '거래 명',
				id: '거래 ID',
				payer: '결제자 명',
				type: '거래 유형',
				status: '상태',
				amount: '결제금액',
				oder_no: '상점 주문 번호',
			},
			modal: {
				title: '상세 조회',
				date1: '오늘',
				date2: '어제',
				date3: '1개월',
				date4: '3개월',
				date5: '6개월',
			},
		},
		setup: {
			language: '언어',
			terms: '약관',
			push_notification: '푸쉬 알림',
		},
	},

	// New UI translation
	new_ui: new_ui.ko_KR,
};
